
<p-panel [toggleable]="false" header="Precode Preferences" >
    <ng-template pTemplate="icons">
        <span data-toggle="tooltip" data-placement="top" [title]="allowReset ? 'Save Preferences' : 'No pending changes to save'">
            <p-button id="buttonStyle" [disabled]=" !allowReset" (onClick)="savePreferences()"> Save</p-button>
        </span>
        <span data-toggle="tooltip" data-placement="top" [title]="allowReset ? 'Cancel Changes' : 'No pending changes to reset'">
            <p-button id="buttonStyle" [disabled]="!allowReset" (onClick)="resetPreferences()"> Reset</p-button>
        </span>
    </ng-template>
    <div style="display: inline-block;width: 75%;">
        <div class="flex flex-row flex-wrap ml-2 mt-0.5  gap-6" style="padding-top: 10px;width: 100%;">
            <div>
                <div>
                    <label class="floatLabels">Crop*</label>
                </div>
                <div>
                    <p-dropdown id="ddl_Crop" [options]="crops" [(ngModel)]="selectedCrop" [showClear]="true" (onChange)="changeCrop(false)" [filter]="true" filterMatchMode="startsWith" optionLabel="Name" placeholder="Select" />
                </div>
            </div>
            <div data-toggle="tooltip" data-placement="top" title="Select Program, Region or EZ">
                <div>
                    <label class="floatLabels">Level </label>
                </div>
                <div>
                    <p-dropdown id="ddl_Level" [style]="{'width':'140px'}" [options]="levels" [showClear]="true" [(ngModel)]="selectedLevel" (onChange)="changeLevel()" optionLabel="name" placeholder="Select" />
                </div>
            </div>
            <div>
                <div>
                    <label class="floatLabels">Include</label>
                </div>
                <div>
                    <ng-select id="ddl_Include" [items]="inclusions" [multiple]=true [closeOnSelect]=false [markFirst]="true" [searchFn]="onLevelSearch" placeholder="Select" bindLabel="code" [(ngModel)]="selectedInclusions">
                        <ng-template ng-option-tmp let-item="item">
                            <div data-toggle="tooltip" data-placement="top" title="{{item.desc}}" style="width: 100%;">{{ item.code }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div data-toggle="tooltip" data-placement="top" title="Select stage to apply filter on search.">
                <div>
                    <label class="floatLabels">Stage</label>
                </div>
                <div>
                    <ng-select id="ddl_Stage" [items]="stages" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select"  [(ngModel)]="selectedStages"></ng-select>
                </div>
            </div>
            <div data-toggle="tooltip" data-placement="top" title="Select year to apply filter on search.">
                <div>
                    <label class="floatLabels">Years</label>
                </div>
                <div>
                    <ng-select id="ddl_Years" [items]="years" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select"  [(ngModel)]="selectedYears"></ng-select>
                </div>
            </div>
            <!-- <div data-toggle="tooltip" data-placement="top" title="Select Gen to get GEID and Name for nesting levels you want to view.">
                <div>
                    <label class="floatLabels" style="margin-top: -22px;width: 160px;">Generations To Summarize</label>
                </div>
                <div>
                    <p-dropdown id="ddl_Gens2Fetch" id="genToFetch" [options]="genList" [showClear]="true" [(ngModel)]="genToFetch" optionLabel="name" />
                </div>
            </div> -->
        </div> 
        <div style="margin-top: 15px;"> 
            <label style="text-transform: capitalize;font-weight: 800;width: 100%;margin-left: 5px;">Expand By :</label>
            <div class="flex flex-row flex-wrap ml-2 pt-2 pb-4 gap-6" >
                <div>
                    <p-checkbox id="chk_GE" [(ngModel)]="geLineageChecked" label="GE Lineage" [binary]="true" inputId="binary" />
                </div>
                <div>
                    <p-checkbox id="chk_Seed" [(ngModel)]="seedInventoryChecked" label="Seed Inventory" [binary]="true" inputId="binary" />
                </div>
                <div>
                    <p-checkbox id="chk_Pop" [(ngModel)]="popRequestChecked" label="Pop Request" [binary]="true" inputId="binary" />
                </div>
                <div>
                    <p-checkbox id="chk_Expt" [(ngModel)]="experimentsChecked" label="Experiments" [binary]="true" inputId="binary" />
                </div>
                <div>
                    <p-checkbox id="chk_Apex" [(ngModel)]="apexVoteChecked" label="APEX Vote" [binary]="true" inputId="binary" />
                </div>
            </div>                               
        </div>
        <div class="grid" style="margin-top: 5px;">
            <div class="col-fixed">
                <label style="text-transform: capitalize;font-weight: 800;width: 100%;margin-left: 5px;">Set Grid Column Header Color :</label>
                <label style="font-style: italic;font-weight:lighter;width: 100%;margin-left: 5px;color: grey;">(click on each color picker to set different colors for each type)</label>
                <div class="grid" style="margin-top: 1px;">
                    <p-menubar [model]="colorOptions" [style]="{'width': '540px'}">
                        <ng-template pTemplate="item" let-item let-root="root">
                            <a class="flex m-2 items-center p-menubar-item-link">                    
                                <p-colorPicker id="btn_{{ item.type }}" [(ngModel)]="item.color" (onChange)="changeHeaderColor($event, item.type)"></p-colorPicker>  
                                <span class="m-1">{{ item.type }}</span>
                            </a>
                        </ng-template>
                    </p-menubar>
                </div>
                <p-button id="btn_Prg" data-toggle="tooltip" data-placement="top" title="Set colors for Program" [disabled]="!selectedCrop" (onClick)="showPrgColorModal()" size="small" [style]="{'margin-top': '10px', 'margin-left': '10px'}">Program Colors</p-button>
                <div style="margin-top: 15px;">
                    <label for="chkSel" style="font-weight: 800; margin-right: 10px;"> Wrap Grid Header </label>
                    <p-checkbox id="chk_WrapHeader" inputId="chkSel" [(ngModel)]="wrapHeader" [binary]="true" inputId="binary" />
                </div>
                <div style="margin-top: 15px;">
                    <label style="font-weight: 800; margin-right: 10px;"> Default Flyout </label>
                    <p-radioButton value="search" [(ngModel)]="flyoutType" label="Search" />
                    <p-radioButton value="sessions" label="Sessions" [style]="{'margin-left': '5px'}" [(ngModel)]="flyoutType" />
                    <p-radioButton value="none" [(ngModel)]="flyoutType" label="None" [style]="{'margin-left': '5px'}" />
                </div>
            </div>
            <div class="col">
                <div class="grid">
                    <label style="font-weight: 800; margin: 4px; margin-left: 7px;">Tags</label>
                    <span data-toggle="tooltip" data-placement="top" title="Copy tags as semicolon separated values">
                        <p-button id="btn_CopyTag" size="small" [style]="{'margin-left': '5px'}" [disabled]="tags.length === 0" (onClick)="copyToClipboard()"> Copy</p-button>
                    </span>
                    <p-button id="btn_ManageTag" data-toggle="tooltip" data-placement="top" title="Manage tags in a modal" size="small" [disabled]="!selectedCrop" [style]="{'margin-left': '5px'}" (onClick)="showTagModal=true"> Manage</p-button>
                </div>
                <p-table id="tbl_Tags" [value]="tags" selectionMode="multiple" [scrollable]="true" scrollHeight="195px" dataKey="tag" [tableStyle]="{ 'width': '20rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Tag</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData.tag }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <div *ngIf="programs.length > 0 && selectedCrop" style="display : inline-block;width: 18%; position: absolute;margin-left: 33px;">
        <div data-toggle="tooltip" data-placement="top" title="Show only selected programs.">
            <p-checkbox id="chk_ShowSel" [(ngModel)]="showSelFavorites" [binary]="true" inputId="selFavorites" (onChange)="changeFavoritesView($event)" [style]="{'margin-bottom': '2px', 'margin-right': '5px'}" />
            <label for="selFavorites">Show Selected</label>
        </div>
        <label data-toggle="tooltip" data-placement="top" title="Set favorite programs for quick filter" style="left: 0.429rem;color: #666666;transition-duration: 0.2s;">My Favourite Programs ({{favouritePrograms.length}} / {{programs.length}})</label>
        <p-listbox id="lst_Favorites" data-toggle="tooltip" data-placement="top" title="Set favorite programs for quick filter"
            [options]="programsCopy" 
            optionLabel="code"
            [(ngModel)]="favouritePrograms"
            filterMatchMode="startsWith"
            [filter]="true" 
            [multiple]="true" 
            [style]="{ width: '15rem', position: 'absolute' }" 
            [listStyle]="{'max-height': '220px'}" />
    </div>
    <br>
    <div class="grid" style="margin-top: 10px;"> 
        <div class="col-6">
            <label style="font-weight: bold;font-size: large;margin-bottom:3px">Germplasm Assessments</label>
            <span  data-toggle="tooltip" data-placement="top" title="Add Germplasm Assessments">
                <p-button id="btn_ManageTraits" size="small" [disabled]="!selectedCrop" (onClick)="addGeAssessments()"> Manage</p-button>
            </span>
            <p-table [value]="geAssessmentsList"  selectionMode="multiple" [(selection)]="selectedAssessments" [scrollable]="true" scrollHeight="350px" dataKey="traitId"  [tableStyle]="{ 'width': '44rem', 'margin-top':'10px' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th>ID</th>
                        <th style="width: 165px;">Assessment Name</th>
                        <th>Assessment Description</th>
                        <th>Source</th>
                        <!-- <th>Region(s)</th>
                        <th>Year(s)</th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr>
                        <td>{{ rowData.traitId }}</td>
                        <td>{{ rowData.traitName }}</td>
                        <td>{{ rowData.traitDescription }}</td>
                        <td>{{ rowData?.source }}</td>
                        <!-- <td>{{ rowData?.aois }}</td>
                        <td>{{ rowData?.years }}</td> -->
                    </tr>
                </ng-template>
            </p-table>
        </div>  
        <div class="col-6">
            <label style="font-weight: bold;font-size: large;margin-bottom:3px">PStage/Vote Settings</label>
            <p-button id="btn_ManagePstage" data-toggle="tooltip" data-placement="top" title="Add PStages and Votes" [disabled]="!selectedCrop" size="small" (onClick)="showPStageDialog()"> Manage</p-button>
            <p-table [value]="pStagesList"  selectionMode="multiple" [(selection)]="selectedPStages" dataKey="id"  [tableStyle]="{ 'width': '44rem', 'margin-top':'10px' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Type</th>
                        <th>Level</th>
                        <th>Name</th>
                        <th>Year</th>                        
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr>
                        <td>{{ rowData.settingType }}</td>
                        <td>{{ rowData.type }}</td>
                        <td>{{ rowData.name }}</td>
                        <td>{{ rowData?.year }}</td>                       
                    </tr>
                </ng-template>
            </p-table>
        </div>  
    </div>
</p-panel>
<p-dialog [modal]="true" [(visible)]="showTagModal" [draggable]="false" [baseZIndex]="10000" [style]="{ 'width': '640px','height': '650px' }" appendTo="body">
    <ng-template pTemplate="header" style="height: 60px;">
        <div class="grid" style="margin-left: 0px; margin-bottom: -10px;">
            <h6 style="margin-right: 35px; margin-top: 3px;">Manage Tags</h6>
            <div style="margin-top: 5px;">
                <p-checkbox id="chk_ShowInactive" [(ngModel)]="showInactiveTags" [binary]="true" inputId="showInactive" (onChange)="toggleActiveTags($event)" [style]="{'margin-bottom': '2px', 'margin-right': '5px'}" />
                <label for="showInactive">Show Inactive Tags</label>
            </div>
            <span data-toggle="tooltip" data-placement="top" title="Remove Tag">
                <p-button id="btn_RemoveTag" [disabled]="!(tagGridApi && tagGridApi.getSelectedRows() && tagGridApi.getSelectedRows().length > 0)" (onClick)="removeSelectedTags()" [style]="{ 'margin-left': '5px' }"> Remove</p-button>
            </span>
            <span data-toggle="tooltip" data-placement="top" title="Merge selected tag with a another existing tag">
                <p-button id="btn_MergeTag" [style]="{'margin-left': '5px'}" [disabled]="!(tagGridApi && tagGridApi.getSelectedRows() && tagGridApi.getSelectedRows().length > 0)" (onClick)="mergeOverlayVisible=!mergeOverlayVisible"> Merge</p-button>
            </span>
            <p-overlay [(visible)]="mergeOverlayVisible" appendTo="body" [responsive]="{ direction: 'top'}" contentStyleClass="w-29rem p-4 bg-surface-0 dark:bg-surface-900 shadow rounded-border">
                <div style="background-color: white; border-radius: 4px; border-style: solid; border-width: 1px; width: 19rem;">
                    <div class="grid" style="margin: 5px; height: 28px;">
                        <label style="font-weight: 800;">Select a tag to merge with</label> 
                        <span data-toggle="tooltip" data-placement="top" title="Merge">
                            <p-button id="btn_MergeTagFromModal" [style]="{'margin-left': '5px', 'margin-top':'-3px'}" size="small" [disabled]="tagToMerge.length === 0" (onClick)="mergeTags()"> OK</p-button>
                        </span>
                    </div>
                    <p-listbox id="lst_MergeTag" *ngIf="mergeOverlayVisible" [options]="mergeOptions" [(ngModel)]="tagToMerge" [multiple]="false" [listStyle]="{'max-height': '150px'}" />
                </div>
            </p-overlay>
            <span data-toggle="tooltip" data-placement="top" title="Close">
                <p-button id="btn_SetTagActive" (onClick)="saveTags()" [style]="{ 'margin-left': '5px' }" [disabled]="!allowTagSave"> Save </p-button>
            </span>
        </div>
    </ng-template>
    <div style="height: 90%;">
        <div class="grid">
            <input id="txt_Tag" type="text" style="width: 538px; margin-left: 7px; margin-right: 5px;" pInputText placeholder="Type a tag or paste a tag list and press enter/click Add" [(ngModel)]="tag" (keyup.enter)="addToTagList()" />
            <p-button id="btn_AddTag" data-toggle="tooltip" data-placement="top" (onClick)="addToTagList()" title="Add Tag" [disabled]="tag.length === 0"> Add</p-button>
        </div>
        <ag-grid-angular id="grd_Tag" *ngIf="tags.length > 0"
        style="height: 100%;margin-top: 5px;" 
        class="ag-theme-balham"
        [rowData]="tags" 
        [columnDefs]="tagColDef"
        [defaultColDef]="defaultPStageColDef" 
        rowSelection="multiple"
        [components]="components"
        [suppressRowClickSelection]=true
        [gridOptions]="gridOptionsTag"
        (gridReady)="onTagGridReady($event)"
       ></ag-grid-angular>
    </div>
</p-dialog>
<p-dialog  [modal]="true" [(visible)]="showPStageModal" [draggable]="false" [closable]="true" [baseZIndex]="10000" [style]="{ 'width': '65%','height': '70vh' }" appendTo="body">
    <ng-template pTemplate="header">
        <div style="display: flex;justify-content: space-between; width: 100%;">
            <h6 style="margin: 0;">Select and Apply PStage/Vote</h6>
            <div>                
                <p-button id="btn_AddPStageRow" data-toggle="tooltip" data-placement="top" (onClick)="addPStageRow()" title="Add Row"> Add Row</p-button>
                <span data-toggle="tooltip" data-placement="top" title="Remove Row">
                    <p-button id="btn_RemovePStage" [disabled]="!(pStageData.length > 0)" (onClick)="deletePStageRow()" [style]="{ 'margin-left': '5px' }"> Remove Row</p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Add and Close">
                    <p-button id="btn_AddPStage" [disabled]="allowPStageSettingSave" (onClick)="savePStageData(true)" [style]="{ 'margin-left': '5px' }"> Update </p-button>
                </span>
                <p-button id="btn_ClosePStage" data-toggle="tooltip" data-placement="top" (onClick)="savePStageData(false)" title="Close" [style]="{ 'margin-left': '5px' }"> Close </p-button>
            </div>
        </div>
    </ng-template>
    <div>
        <ag-grid-angular id="grd_PStage" *ngIf="pStageData.length > 0"
        style="height: 55vh;margin-left: 45px;;margin-top: 5px; width: 90%;" 
        class="ag-theme-balham"
        [rowData]="pStageData" 
        [columnDefs]="pStageColDef"
        [defaultColDef]="defaultPStageColDef" 
        rowSelection="multiple"
        [components]="components"
        [stopEditingWhenCellsLoseFocus]="true"
        [gridOptions]="gridOptionsPStage"
        (gridReady)="onPStageGridReady($event)"
       ></ag-grid-angular>
    </div>
</p-dialog>
<p-dialog [modal]="true" [(visible)]="showProgramColorModel" [draggable]="false" [closable]="true" [baseZIndex]="10000" appendTo="body">
    <ng-template pTemplate="header">
        <div style="display: flex;justify-content: space-between; width: 100%;">
            <h6 style="margin: 0;">Set Program Colors</h6>
            <div>
                <p-button id="btn_ApplyColors" id="applyPrgBtn" (onClick)="closePrgModel()">Apply & close</p-button>
            </div>
        </div>
    </ng-template>
    <div class="grid">
        <label style="margin-right: 5px; margin-top: 7px; margin-left: 8px;">Type</label>
        <p-dropdown id="ddl_TypeColor" [style]="{'width':'140px'}" [options]="types" [(ngModel)]="selType" [showClear]="true" (onChange)="changeType()" optionLabel="name" placeholder="Select" />
        <label style="margin-right: 5px; margin-top: 7px; margin-left: 8px;">Name</label>
        <p-dropdown id="ddl_NameColor" [style]="{'width':'120px'}" [options]="prgRgnEZNames" [(ngModel)]="selPrgRgnEZ" optionLabel="Code" [filter]="true" filterMatchMode="startsWith" [showClear]="true" placeholder="Select" />
        <label style="margin-left: 20px; margin-right: 5px; margin-top: 7px;">Color</label>
        <a class="flex items-center p-menubar-item-link" style="margin-left: 10px; margin-top: 5px;">
            <p-colorPicker id="pck_Color" [(ngModel)]="prgRgnEZColor"></p-colorPicker> 
        </a>
        <div class="grid" style="margin-left: 25px; margin-top: 5px;">
            <p-button id="btn_AddPrgColor" [disabled]="!(selPrgRgnEZ && prgRgnEZColor)" (onClick)="addPrgColor()" size="small">Add</p-button>
            <p-button id="btn_RemPrgColor" [disabled]="!(selPrgRgnEZColors && selPrgRgnEZColors.length > 0)" (onClick)="removePrgColor()" size="small" [style]="{'margin-left': '5px'}">Remove</p-button>
        </div>
    </div>
    <hr width="100%" size="1" style="margin-top: 10px; margin-bottom: 10px;color: lightgray;">
    <label style="font-weight: bold;">Preview Colors</label>
    <div style="height: 270px;">
        <p-table id="tbl_Colors" [value]="prgRgnEZColors" selectionMode="multiple" [(selection)]="selPrgRgnEZColors" dataKey="type"  [tableStyle]="{ 'width': '40rem', 'margin-top':'5px', }"  [scrollable]="true" scrollHeight="270px">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 2rem"><p-tableHeaderCheckbox /></th>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Color</th>                      
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="rowData" />
                    </td>
                    <td>{{ rowData.type.split(':')[0] }}</td>
                    <td>{{ rowData.type.split(':')[1] }}</td>
                    <td [style.backgroundColor]="rowData.color"></td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-dialog>
<p-confirmDialog [style]="{'width' : '450px', 'height' : '230px'}" [closable]="false" appendTo="body">   
</p-confirmDialog> 
